import { Directive, forwardRef, inject, Provider } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator, Validators } from '@angular/forms';
import { I18NextPipe } from 'angular-i18next';

export const ComputerNameMaxLength = 14;

const ComputerNamePattern = /^[a-zA-Z0-9-]+$/;
const ComputerNameFirstSymbolPattern = /^[^0-9].*/;
const ComputerNameLastSymbolPattern = /^.*[^-]$/;

export function isComputerNameValid(value: string): boolean {
  return (
    !!value &&
    value.length <= ComputerNameMaxLength &&
    ComputerNamePattern.test(value) &&
    ComputerNameFirstSymbolPattern.test(value) &&
    ComputerNameLastSymbolPattern.test(value)
  );
}

const ComputerNameValidationProvider: Provider = {
  provide: NG_VALIDATORS,
  useExisting: forwardRef(() => ComputerNameValidationDirective),
  multi: true
};

@Directive({
  providers: [ComputerNameValidationProvider],
  selector: '[mbsComputerNameValidation]',
  standalone: true
})
export class ComputerNameValidationDirective implements Validator {
  private readonly i18nPipe = inject(I18NextPipe);

  public validate(control: AbstractControl): ValidationErrors | null {
    const value = control?.value;

    if (!value) return null;

    const errors: ValidationErrors = {
      ...Validators.maxLength(ComputerNameMaxLength)(control),
      ...(ComputerNamePattern.test(value) ? null : { patternError: { message: this.getMessage('patternError') } }),
      ...(ComputerNameFirstSymbolPattern.test(value) ? null : { firstSymbolError: { message: this.getMessage('firstSymbolError') } }),
      ...(ComputerNameLastSymbolPattern.test(value) ? null : { lastSymbolError: { message: this.getMessage('lastSymbolError') } })
    };

    return Object.keys(errors).length ? errors : null;
  }

  private getMessage(key: string): string {
    return this.i18nPipe.transform(`mbs-ui:cloud-restore.whereToRestoreStep.${key}`);
  }
}
